var jade = require("D:\\Git\\projection-grid\\node_modules\\jade\\lib\\runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (checkAllLabel, checked, partSelected, single) {
if ( single)
{
buf.push("<span></span>");
}
else
{
buf.push("<input type=\"checkbox\"" + (jade.attr("checked", checked, true, true)) + (jade.attr("aria-label", checkAllLabel, true, true)) + (jade.cls(['select-all',partSelected ? 'part-selected' : undefined], [null,true])) + ">");
}}.call(this,"checkAllLabel" in locals_for_with?locals_for_with.checkAllLabel:typeof checkAllLabel!=="undefined"?checkAllLabel:undefined,"checked" in locals_for_with?locals_for_with.checked:typeof checked!=="undefined"?checked:undefined,"partSelected" in locals_for_with?locals_for_with.partSelected:typeof partSelected!=="undefined"?partSelected:undefined,"single" in locals_for_with?locals_for_with.single:typeof single!=="undefined"?single:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./js/vnext/projection/selection-head.jade
// module id = 79
// module chunks = 0